/**
 * WhatsApp template hooks (#1471)
 *
 * Approved templates are the only send permitted once a conversation's 24 h
 * session window has closed, so the composer loads them lazily — only when a
 * closed window actually forces template mode.
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { WhatsAppTemplate } from '@/types';

interface TemplateListResponse {
  data: WhatsAppTemplate[];
}

export function useWhatsAppTemplates(enabled: boolean) {
  return useQuery({
    queryKey: ['whatsapp', 'templates'],
    queryFn: async () => {
      const response = await api.get<TemplateListResponse>('/whatsapp/templates');
      return response.data;
    },
    enabled,
    // Approvals happen in Meta's console, not here — no need to refetch often.
    staleTime: 5 * 60 * 1000,
  });
}
